import { SELF_SERVE_PLAN_DOCS_URL } from "./gauLabels";

// GAU-pack links land on the self-serve plan docs — the old
// building-with-clark/ai-credits page predates the GAU rename.
export const GAU_PACKS_DOCS_URL = SELF_SERVE_PLAN_DOCS_URL;

export function GauPacksLink() {
  return (
    <a
      className="text-[#6c7689] underline"
      href={GAU_PACKS_DOCS_URL}
      rel="noreferrer"
      target="_blank"
    >
      GAU Packs
    </a>
  );
}
